/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolTheatersIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-theaters"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M6.33 19.32L6.33 20Q6.33 20.55 5.94 20.94Q5.55 21.32 5 21.32Q4.45 21.32 4.06 20.94Q3.67 20.55 3.67 20L3.67 4Q3.67 3.45 4.06 3.06Q4.45 2.67 5 2.67Q5.55 2.67 5.94 3.06Q6.33 3.45 6.33 4L6.33 4.67L7.67 4.67L7.67 4Q7.67 3.45 8.06 3.06Q8.45 2.67 9 2.67L15 2.67Q15.55 2.67 15.94 3.06Q16.32 3.45 16.32 4L16.32 4.67L17.68 4.67L17.68 4Q17.68 3.45 18.06 3.06Q18.45 2.67 19 2.67Q19.55 2.67 19.94 3.06Q20.32 3.45 20.32 4L20.32 20Q20.32 20.55 19.94 20.94Q19.55 21.32 19 21.32Q18.45 21.32 18.06 20.94Q17.68 20.55 17.68 20L17.68 19.32L16.32 19.32L16.32 20Q16.32 20.55 15.94 20.94Q15.55 21.32 15 21.32L9 21.32Q8.45 21.32 8.06 20.94Q7.67 20.55 7.67 20L7.67 19.32ZM6.33 16.68L7.67 16.68L7.67 15.32L6.33 15.32ZM6.33 12.68L7.67 12.68L7.67 11.32L6.33 11.32ZM6.33 8.68L7.67 8.68L7.67 7.33L6.33 7.33ZM16.32 16.68L17.68 16.68L17.68 15.32L16.32 15.32ZM16.32 12.68L17.68 12.68L17.68 11.32L16.32 11.32ZM16.32 8.68L17.68 8.68L17.68 7.33L16.32 7.33Z" fill={color} />
    </svg>
  );
}
